var _HelperTooltip;
import { clsx } from "clsx";
import QuestionMarkCircle from "@crehana/compass.icons.outline/QuestionMarkCircle";
import { Tooltip } from "@crehana/ui";
import HelperTooltip from "./HelperTooltip";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HelpLink = function HelpLink(_ref) {
  var sidebarCollapsed = _ref.sidebarCollapsed,
    isDark = _ref.isDark;
  var textColor = 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-600';
  var borderColor = 'tw-border-neutral-light-300 dark:tw-border-elevation-dark-03';
  return /*#__PURE__*/_jsx(Tooltip, {
    label: _HelperTooltip || (_HelperTooltip = /*#__PURE__*/_jsx(HelperTooltip, {
      title: "Ayuda",
      description: "Accede a los recursos y canal de soporte."
    })),
    position: "right",
    hidden: !sidebarCollapsed,
    isDark: isDark,
    children: /*#__PURE__*/_jsx("a", {
      href: "https://ayuda.crehana.com/",
      target: "_blank",
      rel: "noreferrer",
      children: /*#__PURE__*/_jsxs("div", {
        className: clsx('tw-flex tw-items-center tw-py-1.2 tw-px-1.6 tw-border-solid tw-border-t', borderColor, {
          'tw-flex-col tw-items-center': sidebarCollapsed
        }),
        children: [/*#__PURE__*/_jsx(QuestionMarkCircle, {
          size: 16,
          className: textColor
        }), !sidebarCollapsed && /*#__PURE__*/_jsx("p", {
          className: clsx('tw-ml-0.8 tw-font-body5', textColor),
          children: "Ayuda"
        })]
      })
    })
  });
};
export default HelpLink;